import {useState} from "react";
import {twMerge} from "tailwind-merge";
import parse from "html-react-parser";

export default function TextLimiter({text = "", limit = 100, moreText = "بیشتر...", htmlText = false, classes = {}}) {

    const [showAll, setShowAll] = useState(false);
    const {parentClasses = "", textClasses = "", moreClasses = ""} = classes;

    return (
        <div className={parentClasses}>
            <div className={textClasses}>
                {
                    text?.length > limit ?
                        <>
                            {showAll ? (htmlText ? parse(text) : text) : (htmlText ? parse(text) : text.slice(0, limit))}
                            <button
                                onClick={() => setShowAll(true)}
                                className={twMerge(`text-pol-blue inline mr-1 ${showAll ? "hidden" : ""}`, moreClasses)}>
                                {moreText}
                            </button>
                        </>
                        : htmlText ? parse(text) : text
                }
            </div>
        </div>
    )
}

//{showAll ? (htmlText ? parse(text) : text) : (htmlText ? parse(text.slice(0, limit)) : text.slice(0, limit))}
